
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/school-and-free-plan",
      function () {
        return require("private-next-pages/school-and-free-plan.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/school-and-free-plan"])
      });
    }
  